function ev_showbonus(){
    var main=$(".placeEvent.showbonus:visible");
    var canv=main.find(".myCanvasAnimSBO");
    canv.one("was_loaded",function(){
        //start_point,img_name,point_image,speed
        var speed=8;
        canv.startGirlAnim("addAnimRotation",[50,50],"arr_big",[6,28],speed*30);
        canv.startGirlAnim("addAnimRotation",[50,50],"arr_short",[6,21],speed);
    }).startGirlAnim({
        load_images:{
            "arr_big":""+_IMG_SERV+"/gfx/events/showbonus/pointer_big.png",
            "arr_short":""+_IMG_SERV+"/gfx/events/showbonus/pointer_short.png",
        }
    },_eventTimeHandler);
    
    var lightObj={},light_id;
    function makeAnim(light_id){
        _eventTimeHandler.setOne(lightObj[light_id].time,function(){
            lightObj[light_id].img.fadeIn(100,function(){
                lightObj[light_id].img.fadeOut(100,function(){
                    makeAnim(light_id);
                });
            });
        },mt_rand(1000,5000));
    }
    for(light_id=1;light_id<4;light_id++){
        lightObj[light_id]={};
        lightObj[light_id].img=main.find(".light[data-type='"+light_id+"']");
        lightObj[light_id].time=_eventTimeHandler.getNewIndex();
        makeAnim(light_id);
    }
    
    //<div class="light" data-type="1"></div>
}


